import {
  StyledFluidStar,
  StyledStar,
  StyledStarStopBackground,
  StyledStarStopFill,
} from './Rating.styled';

export interface IRatingProps {
  rating: number;
  acceptDecimalPlaces?: boolean;
}

interface IFluidStarProps {
  fillPercentage?: number;
  index: number;
}

const FluidStar = ({ fillPercentage, index }: IFluidStarProps) => {
  const id = `rating-star-${index}`;

  return (
    <StyledFluidStar fill="none" viewBox="0 0 20 20" width="20" height="20">
      <defs>
        <linearGradient id={id}>
          <StyledStarStopFill offset="0%" />
          <StyledStarStopFill offset={`${fillPercentage}%`} />
          <StyledStarStopBackground offset={`${fillPercentage}%`} />
          <StyledStarStopBackground offset="100%" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${id})`}
        d="M9.54 3.066a.5.5 0 0 1 .92 0l1.586 3.684a.5.5 0 0 0 .413.3l3.993.37a.5.5 0 0 1 .284.874l-3.013 2.647a.5.5 0 0 0-.158.486l.882 3.912a.5.5 0 0 1-.743.54l-3.449-2.047a.5.5 0 0 0-.51 0l-3.449 2.047a.5.5 0 0 1-.743-.54l.882-3.912a.5.5 0 0 0-.158-.486L3.264 8.294a.5.5 0 0 1 .284-.873l3.993-.37a.5.5 0 0 0 .413-.3l1.587-3.685Z"
      />
    </StyledFluidStar>
  );
};

export const Rating = ({ rating, acceptDecimalPlaces }: IRatingProps) => {
  const starCount = 5;

  // limit rating to starCount
  const starRating = rating > starCount ? starCount : rating;
  // get half star value
  const halfStar = ((starRating * 10) % 10) / 10;

  if (acceptDecimalPlaces && halfStar) {
    // remove half star from rating
    const removedHalfStar = starRating - halfStar;

    return (
      <>
        {[...Array(starCount)].map((_element, index) => {
          if (index === removedHalfStar) {
            return (
              <FluidStar
                index={index}
                fillPercentage={halfStar * 100}
                key={index}
              />
            );
          }

          return (
            <StyledStar
              width="20"
              height="20"
              $filled={Boolean(removedHalfStar > index)}
              key={index}
            />
          );
        })}
      </>
    );
  }

  return (
    <>
      {[...Array(starCount)].map((_element, index) => (
        <StyledStar
          width="20"
          height="20"
          $filled={Boolean(starRating > index)}
          key={index}
        />
      ))}
    </>
  );
};
